import { Loading, QLoadingShowOptions } from 'quasar';

export const QLoading = {
  show: (option?: QLoadingShowOptions) => {
    return Loading.show(option);
  },
  hide: () => {
    return Loading.hide();
  }
};